import React, { useEffect, useState } from "react";
import Styles from "./AssetsList.module.css";
import Navigation from "../../Layout/Navigation/Navigation";
import { CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import axios from "axios";
import Table from "../../Layout/Table/Table";
import CustomPagination from "../../Layout/Pagination/ui/Pagination";
// import arrowUp from "../../images/arrowUp.svg";
// import arrowDown from "../../images/arrowDown.svg";

const AssetsList = () => {
  const { filed_central_index_key, accession_number } = useParams();
  const [filingsList, setFilingsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortType] = useState("DESC");
  const [sortField] = useState("filed_as_of_date");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);
  const [name, setName] = useState("");
  const [city, setCity] = useState("");
  useEffect(() => {
    const fetchAssets = async () => {
      setLoading(true);
      try {
        const body = {
          filed_central_index_key: filed_central_index_key,
          accession_number: accession_number,
          sortType: sortType,
          sortField: sortField,
          size: rowsPerPage,
          offset: rowsPerPage * page,
        };
        const filings = await axios.post("/api/assets", body);
        setFilingsList(filings.data);
        setCity(filings.data?.results[0]?.filed_city);
        setName(filings.data?.results[0]?.filed_company_conformed_name);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchAssets();
  }, [
    filed_central_index_key,
    accession_number,
    sortField,
    sortType,
    page,
    rowsPerPage,
  ]);

  const formatDate = (string) => {
    if (string.length !== 8) return;
    const year = string.slice(0, 4);
    const month = string.slice(4, 6);
    const day = string.slice(6, 8);
    const stringDate = `${month}/${day}/${year}`;
    return stringDate;
  };

  const columns = [
    {
      accessorKey: "subject_company_conformed_name",
      header: () => <div>Subject Company Name </div>,
      cell: ({ row }) => (
        <div>{row.original.subject_company_conformed_name}</div>
      ),
    },
    {
      accessorKey: "name_of_reporting_person",
      header: () => <div>Reporting Person</div>,
      cell: ({ row }) => <div>{row.original.name_of_reporting_person}</div>,
    },
    {
      accessorKey: "filed_company_conformed_name",
      header: () => <div>Filed Company Name</div>,
      cell: ({ row }) => <div>{row.original.filed_company_conformed_name}</div>,
    },
    {
      accessorKey:
        "aggregate_amount_beneficially_owned_by_each_reporting_person",
      header: () => <div>Aggregate Amount</div>,
      cell: ({ row }) => (
        <div>
          {new Intl.NumberFormat("en-US").format(
            row.original
              .aggregate_amount_beneficially_owned_by_each_reporting_person
          )}
        </div>
      ),
    },
    {
      accessorKey: "percent_of_class_repesented_by_amount_in_row",
      header: () => <div>Percent Amount</div>,
      cell: ({ row }) => (
        <div>{row.original.percent_of_class_repesented_by_amount_in_row}</div>
      ),
    },
    {
      accessorKey: "form_type",
      header: () => <div>Form Type</div>,
      cell: ({ row }) => <div>{row.original.form_type}</div>,
    },
    {
      accessorKey: "filed_as_of_date",
      header: () => <div>Filed Date</div>,
      cell: ({ row }) => {
        return <div>{formatDate(row.original.filed_as_of_date)}</div>;
      },
    },
  ];

  return loading ? (
    <div className={Styles.Loader}>
      <CircularProgress />
    </div>
  ) : (
    <div className={Styles.App}>
      <Navigation />
      <div className={Styles.Hero}>
        <div className={Styles.LeftHero}>
          <h2>{name}</h2>
          <div className={Styles.LeftHeroDetailsWrapper}>
            <div className={Styles.LeftHeroDetails}>
              <p>City:</p>
              <p>{city}</p>
            </div>
            <div className={Styles.LeftHeroDetails}>
              <p>Accession Number:</p>
              <p>{accession_number}</p>
            </div>
          </div>
        </div>
      </div>
      <div className={Styles.TableWrapper}>
        <div>
          <h5>Filings</h5>
          <Table
            data={filingsList?.results ? filingsList.results : []}
            columns={columns}
          />
          <CustomPagination
            count={filingsList?.total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(newPage) => setPage(newPage)}
            onRowsPerPageChange={(newRowsPerPage) => {
              setRowsPerPage(newRowsPerPage);
              setPage(0);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AssetsList;
